// 全局通用函数，挂载在vue原型上
import api from '@/api'
import {Loading } from 'element-ui'

export default {
    globalExportExl (key, value, exlName = '导出列表') {
        const loading = Loading.service({
            lock: true,
            text: '正在导出，请稍候...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        let lunxunrequesttimer = null;
        let lunxunrequest = () => {
            return api.common.getExportStatus(key, value).then((res) => {
                if (res.code == 0 && res.data !== null) {
                    clearTimeout(this.lunxunrequesttimer);
                    lunxunrequesttimer = null;
                    loading.close();
                    api.common.downloadFailFile(res.data.failFilePath).then(response => {
                        let blob = new Blob([response], { type: 'application/x-xls' })
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = exlName + '.xls';
                        link.click()
                    })
                } else {
                    lunxunrequesttimer = setTimeout(() => {
                        lunxunrequest();
                    }, 5000)
                }
            }).catch(() => {
                lunxunrequesttimer = null;
                loading.close();
                this.$message('导出失败!');
            })
        }

        lunxunrequest();
    }
}



// WEBPACK FOOTER //
// ./src/config/common.js